export enum ShuttlesFilter {
  Upcoming = 'UPCOMING',
  Past = 'PAST'
}
